import { Routes } from '@angular/router';
import { AccessDeniedComponent } from './core/components/access-denied/access-denied.component';
import { SwitchAccountComponent } from './core/components/switch-account/switch-account.component';
import { ModuleSwitcherComponent } from './core/components/module-switcher/module-switcher.component';
import { NotificationsComponent } from './core/components/notifications/notifications.component';
import { RootRedirectService } from '@macs-frontend/services/root-redirect.service';
import { createUserPermissionGuard } from '@macs-frontend/auth/guards/user-permission.guard';
import { Permission } from '@macs-gql';
import { clientsPlannerGuard } from '@macs-frontend/auth/guards/clients-planner.guard';
import { RootComponent } from './core/components/root/root.component';
import { DebugTokenComponent } from './auth/containers/debug-token/debug-token.component';

export const routes: Routes = [
  {
    path: 'debug',
    children: [{ path: 'token', component: DebugTokenComponent }],
  },
  {
    path: '',
    component: RootComponent,
    pathMatch: 'full',
    resolve: {
      redirectResolver: RootRedirectService,
    },
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'switch-account',
    component: SwitchAccountComponent,
  },
  {
    path: 'control-center',
    loadChildren: () =>
      import('./features/control-center/control-center.module').then(
        m => m.ControlCenterModule,
      ),
    canLoad: [createUserPermissionGuard(Permission.InterfaceControlCenter)],
  },
  {
    path: 'messages',
    redirectTo: 'control-center/messages',
    pathMatch: 'full',
  },
  {
    path: 'company-management',
    loadChildren: () =>
      import('./features/company-management/company-management.module').then(
        m => m.CompanyManagementModule,
      ),
    canLoad: [createUserPermissionGuard(Permission.InterfaceCompanyManage)],
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./features/public/public.module').then(m => m.PublicModule),
  },
  {
    path: 'human-resources',
    loadChildren: () =>
      import('./features/human-resources/human-resources.module').then(
        m => m.HumanResourcesModule,
      ),
  },
  {
    path: 'time-tracking',
    loadChildren: () =>
      import('./features/time-tracking/time-tracking.module').then(
        m => m.TimeTrackingModule,
      ),
    canLoad: [createUserPermissionGuard(Permission.InterfaceTimeTracking)],
  },
  {
    path: 'personal-profile',
    loadChildren: () =>
      import('./features/personal-profile/personal-profile.module').then(
        m => m.PersonalProfileModule,
      ),
  },
  {
    path: 'clients',
    loadChildren: () =>
      import('@macs-frontend/features/clients-planner/clients-planner.module').then(
        m => m.ClientsPlannerModule,
      ),
    canLoad: [clientsPlannerGuard],
  },
  {
    path: 'location-selector',
    loadChildren: () =>
      import(
        '@macs-frontend/features/shared/modules/location-selector/location-selector.module'
      ).then(m => m.LocationSelectorModule),
  },
  {
    path: 'modules',
    component: ModuleSwitcherComponent,
    outlet: 'modal',
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    outlet: 'modal',
  },
];
